// NotHappyCard.js — "Not happy with your plan?" promotional card with start-over button
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props
 * @param {boolean} props.isPremium
 * @param {Function} props.onNavigateToWizard
 * @param {Function} props.onOpenTriesLeft - Opens the TriesLeftDrawer for free users
 */
function NotHappyCard({ isPremium, onNavigateToWizard, onOpenTriesLeft }) {
  const { t } = useTranslation(['mealplan', 'common']);

  const handleStartOver = () => {
    if (isPremium) {
      onNavigateToWizard();
    } else {
      onOpenTriesLeft();
    }
  };

  return (
    <div className="mt-8 max-w-5xl mx-auto px-6">
      <div
        className="transition flex-1 p-5 overflow-hidden rounded-[12px] border-[0.5px] border-[var(--Color-Grays-Gray-2,#fff)] bg-[var(--Color-Grays-Gray-075,#EBEBEA)] flex flex-col"
      >
        <h3 className="text-lg font-semibold mb-2">
          {t('premium.notHappy', { ns: 'common' })}
        </h3>
        <p className="text-[#56554D] text-[14px] mb-5">
          {t('premium.notHappyDescription', { ns: 'common' })}
        </p>

        {/* Illustration */}
        <div
          className="flex w-full aspect-[3/2] sm:aspect-[3/1] rounded-[6px] mb-5 items-center justify-center relative bg-cover bg-top"
          style={{
            backgroundImage: `url(/assets/mealplan-promo.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />

        <button
          className="
            relative
            inline-flex justify-center items-center gap-1
            h-[44px] px-[24px] py-[14px]
            rounded-[8px]
            border-[1px] border-[linear-gradient(200deg,_#0D0C07%,_#353227_100%)]
            text-[#FFF] text-center
            text-[14px] font-medium leading-[28px]
            transition-colors
            w-full
            bg-[#0D0C07]
            shadow-[0_2px_16px_0_rgba(0,0,0,0.12)_inset,_0_0_32px_0_rgba(255,255,255,0.4)_inset,_0_0px_0px_1px_rgba(13,12,7,0.4)]
            cursor-pointer bg-[linear-gradient(200deg,_#0D0C07%,_#353227_100%)] md:hover:border-[#252218] md:hover:bg-[#252218]
          "
          onClick={handleStartOver}
        >
          <span>{t('actions.startOver', { ns: 'mealplan' })}</span>
        </button>
      </div>
    </div>
  );
}

export default NotHappyCard;
